module.exports = __webpack_public_path__ + "img/xt1.d89e3ed0.jpg";